/**
 * 全局混合
 */
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { PostRes } from '@/store/pages/report/index.d';
import { dateFormate, fetchReportAfterRecovery } from '@/utils/report';
import CommonMixin from '@/mixins/common.mixin';
const Report = namespace('report');

@Component
export default class DailyBusinessTrendReport extends CommonMixin {
  @Report.Action('getDailyBusinessTrendReport') private getDailyBusinessTrendReport: any;
  @Report.Action('exportDailyBusinessTrendReport') private exportDailyBusinessTrendReport: any;
  @Report.Action('recoveryDailyBusinessTrendReport') private recoveryDailyBusinessTrendReport: any;
  public exportReport() {
    this.exportDailyBusinessTrendReport({
      reportId: this.reportId, 
      level: this.level, 
      start_date: dateFormate(this.start),  
      end_date: dateFormate(this.end), 
      store_group_id: this.store_group_id
    });
  }
  public recovery() {
    this.recoveryDailyBusinessTrendReport({reportId: this.reportId, level: this.level}).then((res: PostRes) => {
      this.fetchReport();
    });
  }
  public fetchReport() {
    fetchReportAfterRecovery(this, 'getDailyBusinessTrendReport');
  }
}
